"use client"

import { useMemo, useState } from "react"
import { PLATFORMS } from "@/lib/breach/directory/platforms"
import { Chips, Contact, NeedsCheck, OfficialLinks, SearchBox, useHashTarget } from "./directory-ui"
import { cn } from "@/lib/utils"

export function PlatformDirectory({ anchor }: { anchor?: string } = {}) {
  const [q, setQ] = useState("")
  const [cat, setCat] = useState("all")
  const target = useHashTarget(anchor)
  const cats = useMemo(() => [{ id: "all", label: "All" }, ...[...new Set(PLATFORMS.map((p) => p.category))].map((c) => ({ id: c, label: c }))], [])
  const list = useMemo(() => {
    const n = q.trim().toLowerCase()
    return PLATFORMS.filter((p) => (cat === "all" || p.category === cat) && (!n || p.name.toLowerCase().includes(n)))
  }, [q, cat])

  if (PLATFORMS.length === 0) return <p className="rounded-lg border border-border p-4 text-muted-foreground">Coming soon.</p>
  return (
    <div>
      <SearchBox value={q} onChange={setQ} placeholder="Search your platform (for example Microsoft, Shopify, AWS)" count={list.length} total={PLATFORMS.length} />
      <Chips options={cats} value={cat} onChange={setCat} label="Filter by type" />
      {list.length === 0 && <p className="mt-6 rounded-lg border border-border p-4 text-sm text-muted-foreground">We don&apos;t list that platform. See &ldquo;If your platform isn&apos;t listed&rdquo; below.</p>}
      <ul className="mt-6 grid gap-4">
        {list.map((p) => {
          const links = [
            p.securityReportUrl && { label: "Report a security incident", url: p.securityReportUrl },
            p.accountRecoveryUrl && { label: "Recover a compromised account", url: p.accountRecoveryUrl },
            p.auditLogsUrl && { label: "Export audit or sign-in logs", url: p.auditLogsUrl },
            ...p.otherUrls,
          ].filter((x): x is { label: string; url: string } => !!x)
          return (
            <li key={p.id} id={p.id} className={cn("scroll-mt-6 rounded-lg border p-4", target === p.id ? "border-accent bg-accent/10" : "border-border")}>
              <div className="flex flex-wrap items-baseline justify-between gap-2"><h3 className="text-lg font-semibold">{p.name}</h3><span className="text-xs text-muted-foreground">{p.category}</span></div>
              <OfficialLinks links={links} />
              <Contact phone={p.supportPhone} />
              {p.notes && <p className="mt-2 text-xs text-muted-foreground">{p.notes}</p>}
              <NeedsCheck show={p.needsCheck} />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
